import { render, staticRenderFns } from "./SimpleType.vue?vue&type=template&id=21b13f98"
import script from "./SimpleType.vue?vue&type=script&lang=js"
export * from "./SimpleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports